import React from 'react';
import { motion } from 'framer-motion';
import { Search, FileWarning, Repeat, Users, Clock, Briefcase } from 'lucide-react';
const pains = [{
  Icon: Search,
  title: 'Buscás ejercicios por todos lados',
  desc: 'Y nunca encontrás exactamente lo que necesitás para tu categoría.'
}, {
  Icon: FileWarning,
  title: 'Guardás videos y PDFs que desaparecen',
  desc: 'Tenés capturas de pantalla y links que después no encontrás cuando estás armando la sesión.'
}, {
  Icon: Repeat,
  title: 'Repetís los mismos entrenamientos',
  desc: 'Porque no tenés tiempo para preparar nuevos y terminás haciendo siempre lo mismo.'
}, {
  Icon: Users,
  title: 'Los chicos se distraen rápido',
  desc: 'Cuesta mantener el interés cuando los ejercicios no son dinámicos o adecuados a su edad.'
}, {
  Icon: Clock,
  title: 'Terminás armando todo el mismo día',
  desc: 'Llegás a la cancha pensando en el camino qué vas a hacer hoy.'
}, {
  Icon: Briefcase,
  title: 'Te llevás trabajo a casa',
  desc: 'Todas las semanas perdiendo horas de descanso intentando planificar la fecha.'
}];
export function PainSection() {
  return <section className="py-20 lg:py-24 bg-white" data-id="element-137">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-14 max-w-3xl mx-auto" data-id="element-139">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-50 text-brand-700 font-bold text-xs uppercase tracking-wider mb-5 border border-brand-100" data-id="element-140">
            ¿Te pasa esto?
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold text-ink-900 mb-4 leading-tight tracking-tight" data-id="element-141">
            Si sos entrenador, esto{' '}
            <span className="text-brand-500" data-id="element-142">seguramente te pasa</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-143">
          {pains.map((pain, i) => {
          const Icon = pain.Icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.06
          }} className="bg-ink-50 rounded-2xl p-6 border border-ink-100 hover:border-brand-200 hover:bg-white hover:shadow-card transition-all" data-id="element-144">
                <div className="w-12 h-12 rounded-xl bg-white text-brand-500 flex items-center justify-center mb-4 shadow-soft border border-ink-100" data-id="element-145">
                  <Icon className="w-6 h-6" data-id="element-146" />
                </div>
                <h3 className="font-bold text-lg text-ink-900 mb-2 leading-tight" data-id="element-147">
                  {pain.title}
                </h3>
                <p className="text-ink-600 text-sm leading-relaxed" data-id="element-148">
                  {pain.desc}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}